import React from 'react';
import { VictimsPageProvider } from '../../components/VictimsPageProvider';

export const HeroesPage: React.FC = () => {
  return (
    <VictimsPageProvider isMilitary isBrigades={false} />
  );
};
